var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBottom24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 14.8247C11.8029 14.8246 11.6082 14.7842 11.4276 14.706C11.247 14.6277 11.0844 14.5133 10.9498 14.3697L7.38477 10.6097L8.61477 9.43969L11.9998 12.9997L15.3848 9.42969L16.6148 10.5997L13.0498 14.3697C12.9151 14.5133 12.7525 14.6277 12.5719 14.706C12.3913 14.7842 12.1966 14.8246 11.9998 14.8247Z",
    fill: "#6A7081"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBottom24Line);
export default __webpack_public_path__ + "static/media/icon_arrow_bottom_24_line.6ae42903fb526dc609e28ad313f1eb0c.svg";
export { ForwardRef as ReactComponent };